export enum AppScenes {
  GAME = "GameScene",
  RESOURCE = "ResourceScene",
  EDITOR = "EditorScene",
  BACKGROUND = "BackgroundScene",
}